import { z } from "../../wire/zod";

export const getUserMappingSettingsResponseSchema = z.object({
  settings: z.object({
    auto: z
      .boolean()
      .describe("the strategy maps users that have no mapping by matching e-mail addresses"),
    manual: z
      .boolean()
      .describe(
        "turning it off irreversibly deletes every mapping of the connection whose source is `manual`",
      ),
  }),
});
export const getUserMappingsResponseSchema = z.object({
  mappings: z
    .array(
      z.object({
        userId: z.string(),
        source: z.enum(["manual", "email"]),
        unmappedReason: z
          .enum([
            "no_alm_user",
            "alm_email_not_visible",
            "multiple_alm_users",
            "alm_user_taken",
            "mapped_to_no_alm_user",
          ])
          .optional(),
      }),
    )
    .describe(
      "one entry per requested user that has a mapping record in this connection; a user absent from this list has never been mapped or attempted in it",
    ),
  almType: z.enum(["jira", "ado", "ac"]),
});
export const noDataSchema = z.record(z.string(), z.never());
